import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Button, Form, Row, Col, Modal } from "react-bootstrap";
import DatePicker from "react-datepicker";
import Axios from "axios";
import moment from "moment";
import { useParams, useNavigate } from "react-router-dom";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as NewSaleStyles from "../../styles/sales";

function NewSale(props) {
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();

    const [data, setData] = useState({
        values: {
            title: "",
            code: "",
            couponID: "",
            saleType: "money",
            saleTypeValue: "",
            condition: "oneoff",
            conditionValue: "",
            startDate: new Date(),
            endDate: new Date(),
            active: true
        },
        valids: {
            title: false,
            code: false,
            couponID: false,
            saleTypeValue: false,
            conditionValue: true
        },
        touched: {
            title: false,
            code: false,
            couponID: false,
            saleTypeValue: false
        },
        wholeForm: false,
        triedToSubmit: false,
        canEdit: true
    });

    const [example, setExample] = useState({
        amount: "38.99",
        code: "",
        total: 0,
        saleValid: true
    });

    const [goBackModal, setGoBackModal] = useState({
        open: false,
        header: "",
        message: ""
    });

    function handleCloseGoBackModal() {
        setGoBackModal((prevState) => {
            return { ...prevState, open: false };
        });
        navigate(-1);
    }

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("3D Printing Service - New Sale"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("3D Printing Service"));

        if (props.modify) {
            handleLoad();
        } else {
            const values = { ...data.values };
            values.endDate = data.values.endDate.setDate(values.startDate.getDate() + 1);

            setData((prevState) => {
                return { ...prevState, values };
            });
        }
    }, []);

    function handleLoad() {
        const data = { uuid: params.id };
        Axios.post("/pods/3dPrintingShop/loadOneSale", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    const startDateString = data.saleDetails.startDate.split("/");
                    const endDateString = data.saleDetails.endDate.split("/");

                    const values = {
                        title: data.saleDetails.title,
                        code: data.saleDetails.code,
                        couponID: data.saleDetails.couponID,
                        saleType: data.saleDetails.type,
                        saleTypeValue: data.saleDetails.typeValue,
                        conditionValue: data.saleDetails.conditionValue,
                        condition: data.saleDetails.condition,
                        startDate: Date.parse(`${startDateString[1]}/${startDateString[0]}/${startDateString[2]}`),
                        endDate: Date.parse(`${endDateString[1]}/${endDateString[0]}/${endDateString[2]}`),
                        active: data.saleDetails.active == "true"
                    };

                    const mStarDate = moment(data.saleDetails.startDate, "DD/MM/YYYY");
                    const mNow = moment();

                    let canEdit = true;

                    if (mNow.isSameOrAfter(mStarDate)) {
                        canEdit = false;
                    }

                    const valids = {
                        title: true,
                        code: true,
                        couponID: true,
                        saleTypeValue: true,
                        conditionValue: true
                    };

                    setData((prevState) => {
                        return { ...prevState, values, valids, wholeForm: true, canEdit: canEdit };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    function handleStartDateChange(date) {
        const values = data.values;

        values.startDate = date;

        setData((prevState) => {
            return { ...prevState, values };
        });
    }

    function handleEndDateChange(date) {
        const values = data.values;

        values.endDate = date;

        setData((prevState) => {
            return { ...prevState, values };
        });
    }

    function handleChangeCondition(setting) {
        const values = { ...data.values };
        const valids = { ...data.valids };

        values.condition = setting;
        values.conditionValue = "0";

        let isValid = true;

        if (setting == "overcertainAmount" && values.conditionValue == "") {
            isValid = false;
        }

        valids["conditionValue"] = isValid;

        const allTrue = Object.keys(valids).every(function (k) {
            return valids[k] === true;
        });

        setData((prevState) => {
            return { ...prevState, values, valids, wholeForm: allTrue };
        });

        handleWorkOutTotal(example.amount, values);
    }

    function handleChangeSaleType(setting) {
        const values = { ...data.values };

        values.saleType = setting;

        setData((prevState) => {
            return { ...prevState, values };
        });

        handleWorkOutTotal(example.amount, values);
    }

    function handleOnTouched(event) {
        const { name } = event.target;

        const touches = { ...data.touched };

        touches[name] = true;

        setData((prevState) => {
            return { ...prevState, touched: touches };
        });
    }

    function handleTextChange(event) {
        const { name, value } = event.target;

        const values = { ...data.values };
        const valids = { ...data.valids };

        values[name] = value;

        let isValid = false;
        if (value != "") {
            isValid = true;
        }

        valids[name] = isValid;

        const allTrue = Object.keys(valids).every(function (k) {
            return valids[k] === true;
        });

        setData((prevState) => {
            return { ...prevState, values, valids, wholeForm: allTrue };
        });

        handleWorkOutTotal(example.amount, values);
    }

    function handleOnSave() {
        if (!data.wholeForm) {
            const newTouches = Object.assign(...Object.keys(data.touched).map((k) => ({ [k]: true })));
            setData((prevState) => {
                return { ...prevState, touched: newTouches, triedToSubmit: true };
            });
        } else {
            const axiosData = {
                title: data.values.title,
                code: data.values.code,
                couponID: data.values.couponID,
                type: data.values.saleType,
                typeValue: data.values.saleTypeValue,
                condition: data.values.condition,
                conditionValue: data.values.conditionValue,
                startDate: moment(data.values.startDate).format("DD/MM/YYYY"),
                endDate: moment(data.values.endDate).format("DD/MM/YYYY")
            };
            Axios.post("/pods/3dPrintingShop/addSale", axiosData)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "null") {
                        setGoBackModal({ header: "Insert Sales", message: "Sale inserted successfully!", open: true });
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function handleOnUpdate() {
        if (!data.wholeForm) {
            const newTouches = Object.assign(...Object.keys(data.touched).map((k) => ({ [k]: true })));
            setData((prevState) => {
                return { ...prevState, touched: newTouches, triedToSubmit: true };
            });
        } else {
            const axiosData = {
                uuid: params.id,
                title: data.values.title,
                code: data.values.code,
                couponID: data.values.couponID,
                type: data.values.saleType,
                typeValue: data.values.saleTypeValue,
                condition: data.values.condition,
                conditionValue: data.values.conditionValue,
                startDate: moment(data.values.startDate).format("DD/MM/YYYY"),
                endDate: moment(data.values.endDate).format("DD/MM/YYYY")
            };
            Axios.post("/pods/3dPrintingShop/updateSale", axiosData)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "null") {
                        setGoBackModal({ header: "Update Sale", message: "Sale updated successfully!", open: true });
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function handleExampleTextChange(event) {
        const { name, value } = event.target;

        setExample((prevState) => {
            return { ...prevState, [name]: value };
        });

        handleWorkOutTotal(value, data.values);
    }

    function handleNumberKeyPress(event) {
        if (!/[0-9.]/.test(event.key)) {
            event.preventDefault();
        }
    }

    function handleWorkOutTotal(exampleAmount, values) {
        const amount = parseFloat(exampleAmount) * 100;
        const takeAwayValue = parseFloat(values.saleTypeValue);
        console.log(amount);
        let saleValid = true;
        let total = 0;

        if (values.condition == "overcertainAmount") {
            const overAmount = parseFloat(values.conditionValue) * 100;

            if (amount < overAmount) {
                saleValid = false;
            }
        }
        if (saleValid) {
            if (values.saleType == "money") {
                const takeOff = takeAwayValue * 100;
                total = amount - takeOff;
            }
            if (values.saleType == "percentage") {
                const percent = (amount / 100) * takeAwayValue;
                total = amount - percent;
            }
        }
        setExample((prevState) => {
            return { ...prevState, total: total / 100, saleValid };
        });
    }

    function handleChangeSaleActiveStatus(status) {
        const axiosData = { uuid: params.id, active: status.toString() };
        Axios.post("/pods/3dPrintingShop/activeSaleStatus", axiosData)
            .then((res) => {
                const resData = res.data;
                if (resData.error == "null") {
                    const values = { ...data.values };
                    values.active = status;
                    setData((prevState) => {
                        return { ...prevState, values };
                    });
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={NewSaleStyles.body}>
            <Row>
                <Col>
                    <Row>
                        <Col sm={4} style={NewSaleStyles.controlContainer}>
                            Title:
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    disabled={data.canEdit ? false : true}
                                    type="text"
                                    isInvalid={data.touched.title && !data.valids.title}
                                    name="title"
                                    value={data.values.title}
                                    onChange={handleTextChange}
                                    onBlur={handleOnTouched}
                                    maxLength={50}
                                />
                                <Form.Control.Feedback type="invalid">Please enter a title!</Form.Control.Feedback>
                                <div style={NewSaleStyles.counter}>{50 - data.values.title.length}/50</div>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col sm={4} style={NewSaleStyles.controlContainer}>
                            Code:
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    disabled={data.canEdit ? false : true}
                                    type="text"
                                    isInvalid={data.touched.code && !data.valids.code}
                                    name="code"
                                    value={data.values.code}
                                    onChange={handleTextChange}
                                    onBlur={handleOnTouched}
                                    maxLength={20}
                                />
                                <Form.Control.Feedback type="invalid">Please enter a code!</Form.Control.Feedback>
                                <div style={NewSaleStyles.counter}>{20 - data.values.code.length}/20</div>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col sm={4} style={NewSaleStyles.controlContainer}>
                            Stripe Coupon ID:
                        </Col>
                        <Col>
                            <Form.Group>
                                <Form.Control
                                    disabled={data.canEdit ? false : true}
                                    type="text"
                                    isInvalid={data.touched.couponID && !data.valids.couponID}
                                    name="couponID"
                                    value={data.values.couponID}
                                    onChange={handleTextChange}
                                    onBlur={handleOnTouched}
                                    maxLength={20}
                                />
                                <Form.Control.Feedback type="invalid">Please enter the Strpe Coupon ID!</Form.Control.Feedback>
                                <div style={NewSaleStyles.counter}>{20 - data.values.couponID.length}/20</div>
                            </Form.Group>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col sm={4}>Sale Type:</Col>
                        <Col style={NewSaleStyles.controlContainer}>
                            <Form.Check
                                disabled={data.canEdit ? false : true}
                                type="radio"
                                checked={data.values.saleType == "money"}
                                label="Money Off"
                                onChange={handleChangeSaleType.bind(this, "money")}
                            />
                            <Form.Check
                                disabled={data.canEdit ? false : true}
                                type="radio"
                                checked={data.values.saleType == "percentage"}
                                label="Percentage Off"
                                onChange={handleChangeSaleType.bind(this, "percentage")}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col sm={4}></Col>
                        <Col style={NewSaleStyles.controlContainer}>
                            {data.values.saleType == "money" && "£"}
                            <Form.Group>
                                <Form.Control
                                    disabled={data.canEdit ? false : true}
                                    isInvalid={data.touched.saleTypeValue && !data.valids.saleTypeValue}
                                    type="text"
                                    name="saleTypeValue"
                                    value={data.values.saleTypeValue}
                                    onChange={handleTextChange}
                                    onBlur={handleOnTouched}
                                    onKeyPress={handleNumberKeyPress}
                                    maxLength={10}
                                />
                                <Form.Control.Feedback type="invalid">Please put a value!</Form.Control.Feedback>
                            </Form.Group>
                            {data.values.saleType == "percentage" && "%"}
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col sm={4}>Condition:</Col>
                        <Col style={NewSaleStyles.controlContainer}>
                            <Form.Check
                                disabled={data.canEdit ? false : true}
                                type="radio"
                                checked={data.values.condition == "oneoff"}
                                label="One off transaction"
                                onChange={handleChangeCondition.bind(this, "oneoff")}
                            />
                            <Form.Check
                                disabled={data.canEdit ? false : true}
                                type="radio"
                                checked={data.values.condition == "overcertainAmount"}
                                label="Over or equal a certain amount"
                                onChange={handleChangeCondition.bind(this, "overcertainAmount")}
                            />
                        </Col>
                    </Row>
                    {data.values.condition == "overcertainAmount" && (
                        <div>
                            <br />
                            <Row>
                                <Col sm={4}></Col>
                                <Col>
                                    <Form.Group>
                                        <Form.Control
                                            disabled={data.canEdit ? false : true}
                                            isInvalid={data.triedToSubmit && !data.valids.conditionValue}
                                            type="text"
                                            name="conditionValue"
                                            value={data.values.conditionValue}
                                            onChange={handleTextChange}
                                            maxLength={10}
                                        />
                                        <Form.Control.Feedback type="invalid">Please put an amount!</Form.Control.Feedback>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </div>
                    )}
                    <br />
                    <Row>
                        <Col sm={4} style={NewSaleStyles.controlContainer}>
                            Start Date:
                        </Col>
                        <Col>
                            <DatePicker
                                disabled={data.canEdit ? false : true}
                                dateFormat="dd/MM/yyyy"
                                selected={data.values.startDate}
                                onChange={(date: Date) => handleStartDateChange(date)}
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col sm={4} style={NewSaleStyles.controlContainer}>
                            End Date:
                        </Col>
                        <Col style={NewSaleStyles.controlContainer}>
                            <DatePicker
                                disabled={data.canEdit ? false : true}
                                dateFormat="dd/MM/yyyy"
                                selected={data.values.endDate}
                                onChange={(date: Date) => handleEndDateChange(date)}
                            />
                        </Col>
                    </Row>
                </Col>
                <Col>
                    <Row>
                        <Col style={NewSaleStyles.exampleHeading}>
                            <h3>Example</h3>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4} style={NewSaleStyles.controlContainer}>
                            Amount:
                        </Col>
                        <Col style={NewSaleStyles.controlContainer}>
                            £<Form.Control type="text" name="amount" value={example.amount} onChange={handleExampleTextChange} />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col style={NewSaleStyles.exampleContainer}>
                            <strong>Discount Code: </strong> {data.values.code} <br />- {data.values.saleType == "money" && "£"}
                            {data.values.saleTypeValue}
                            {data.values.saleType == "percentage" && "%"}
                            <br /> <br />
                            {example.saleValid ? (
                                <strong style={isNaN(example.total) ? NewSaleStyles.hidden : NewSaleStyles.unHidden}>
                                    £{example.total.toFixed(2)}
                                </strong>
                            ) : (
                                <div>This sale is not valid</div>
                            )}
                        </Col>
                    </Row>
                </Col>
            </Row>
            <Row>
                <Col>
                    {!data.canEdit && (
                        <div style={NewSaleStyles.saleError}>
                            <br />
                            You cannot edit a sale after it has started
                        </div>
                    )}
                </Col>
                <Col style={NewSaleStyles.columnRight}>
                    {props.modify ? (
                        <div>
                            {data.values.active ? (
                                <Button onClick={handleChangeSaleActiveStatus.bind(this, false)}>Deactivate</Button>
                            ) : (
                                <Button onClick={handleChangeSaleActiveStatus.bind(this, true)}>Activate</Button>
                            )}
                            {data.canEdit && <Button onClick={handleOnUpdate}>Update</Button>}
                        </div>
                    ) : (
                        <Button onClick={handleOnSave}>Save</Button>
                    )}
                </Col>
            </Row>
            <Modal show={goBackModal.open} onHide={handleCloseGoBackModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{goBackModal.header}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{goBackModal.message}</Modal.Body>
                <Modal.Footer>
                    <Button onClick={handleCloseGoBackModal}>Close</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default NewSale;
